import get from 'lodash/get';
import moment from 'moment';

/* Column configuration for audit log table */
const AuditLogsColumnConfig = [{
    id: 'event',
    Header: 'Event Type',
    accessor: props => props.event.eventName,
    minWidth: 70,
}, {
    id: 'userName',
    Header: 'User',
    accessor: props => `${props.user.firstName} ${props.user.lastName}`,
    minWidth: 50,
}, {
    Header: 'Created Date',
    accessor: 'createdAt',
    Cell: props => {
        const { value } = props;
        return (<span>{moment(value).format('LLL')}</span>);
    },
    minWidth: 70,
}, {
    id: 'comment',
    Header: 'Comment',
    accessor: props => get(props, 'commentText', 'NA'),
    minWidth: 200,
}];

export default AuditLogsColumnConfig;
